export default __webpack_public_path__ + "static/media/m_foodieBooster01.118effdf.png";